<template>
  <el-menu :default-active="1" @select="selectMenu" class="side h-100 base-bg over-auto" text-color="#fff">
    <template v-for="(item, idx) in menu" :key="item.meta.id">
      <el-sub-menu :index="(item.path as string)" v-if="item.children?.length">
        <template #title>
          <Component :is="item.meta?.icon" v-if="item.meta?.icon"></Component>
          <span>{{ item.meta?.title }}</span>
        </template>
        <el-menu-item :index="it.name as string" v-for="(it, index) in item.children" :key="(it.meta?.id as string)">{{ it.meta?.title }}</el-menu-item>
      </el-sub-menu>
      <el-menu-item :index="item.name as string" v-else>
        <Component :is="item.meta?.icon" v-if="item.meta?.icon"></Component>
        <span>{{ item.meta?.title }}</span>
      </el-menu-item>
    </template>

  </el-menu>
</template>

<script setup lang="ts">
import { defineProps, reactive, ref, watch, Ref, defineExpose, toRefs } from 'vue';
import { useRouter, useRoute, NavigationFailureType, isNavigationFailure } from 'vue-router';
import type { RouteRecordRaw } from "vue-router";
import { useStore } from 'vuex';
import { pathType } from '@/util/interface/route/route';



const props = withDefaults(defineProps<{
  menu: RouteRecordRaw[]
}>(), {
  menu: () => []
});
// const emit = defineEmits<{

// }>()

const route = useRoute()
const router = useRouter();
const store = useStore();

const { menu } = toRefs(props)

const state = reactive({
  activeName: ''
})

// watch(() => route.name, val => {


//     let activeName = isInMenu(val as string, store.state.menuList);
//     if(activeName) {
//         state.activeName = activeName
//     }else {
//         let pSort = (route.meta?.sort + '')[0];
//         let data = store.state.menuList.filter((t: any) => t.meta?.sort == pSort)[0];
//         state.activeName = data.name as string
//         console.log(route)
//     }
//     console.log(state.activeName)
// })

const selectMenu = async (name: string) => {
  let data = store.state.routeOriginList.filter((t: any) => t.code == name)[0];
  switch(data.pathType) {
    case pathType.mine:
      const failRouter = await router.push({ name });
      // 检测路由跳转，失败则去到notFound
      if (isNavigationFailure(failRouter, NavigationFailureType.aborted)) {
        router.push({ path: '/notFound' })
      }

      break;
    case pathType.iframe:
      let arr = data.path.split('#');
      let path = arr[1].match(/\?/) || '';
      if (path) {
        path = '&token=' + store.state.accessToken
      } else {
        path = '?token=' + store.state.accessToken
      }
      console.log(path)
      router.push({
        name: 'webIframe',
        query: {
          url: encodeURIComponent(`${arr[0]}?_times=${new Date().getTime()}/#${arr[1]}${path}`)
        }
      })
      break;
    case pathType.tag:
      let tagarr = data.path.split('#');
      let tagpath = tagarr[1].match(/\?/) || '';
      if (tagpath) {
        tagpath = '&token=' + store.state.accessToken
      } else {
        tagpath = '?token=' + store.state.accessToken
      }
      console.log(tagpath)
      window.open(`${tagarr[0]}?_times=${new Date().getTime()}/#${tagarr[1]}${tagpath}`)
      // 
      break;

  }
}

const {
  activeName
} = toRefs(state)
</script>

<style lang="scss" scoped>
@import '../../../static/style/variable.scss';

.el-menu {
  // padding-left: $separation-medium;
  // padding-right: $separation-medium;
  background-color: $primary-text;
  &-item {
    background-color: $primary-text;
    &:hover {
      background-color: var(--el-color-primary);
      &.is-active {
        color: #fff;
      }
    }
  }
  :deep() .el-sub-menu {
    &__title {
      &:hover {
        background-color: var(--el-color-primary);
      }
    }
  }
}

</style>
